import React from "react";
import "./Services.css";
import {
  FaCar,
  FaHotel,
  FaUtensils,
  FaLandmark,
  FaTrain,
  FaMapMarkedAlt,
  FaMountain,
} from "react-icons/fa";

const services = [
  {
    icon: <FaCar />,
    title: "Transportation",
    desc: "Private AC vehicles, airport transfers, intercity travel and complete transportation solutions across India.",
  },
  {
    icon: <FaHotel />,
    title: "Bed & Breakfast",
    desc: "Comfortable hotel stays with daily breakfast from budget to luxury heritage properties.",
  },
  {
    icon: <FaUtensils />,
    title: "Culinary Classes",
    desc: "Learn authentic Indian cooking with local chefs and experience traditional flavors.",
  },
  {
    icon: <FaLandmark />,
    title: "Delhi City Tour",
    desc: "Explore Old & New Delhi including monuments, markets, heritage sites and cultural experiences.",
  },
  {
    icon: <FaTrain />,
    title: "Agra Train Tour",
    desc: "Same-day Taj Mahal tour by superfast train with guide, transfers and sightseeing included.",
  },
  {
    icon: <FaMapMarkedAlt />,
    title: "Golden Triangle Tour",
    desc: "Discover Delhi, Agra & Jaipur — India’s most famous cultural travel circuit.",
  },
  {
    icon: <FaMountain />,
    title: "Rajasthan Tour",
    desc: "Royal Rajasthan journeys covering Jaipur, Udaipur, Jodhpur, desert experiences and forts.",
  },
];

const Services = () => {
  return (
    <section className="services-page">

      {/* HERO */}
      <div className="services-hero">
        <h1>Our Travel Services</h1>
        <p>
          City Linkers Tours & Travels provides complete travel solutions
          designed for comfort, culture, and unforgettable experiences.
        </p>
      </div>

      {/* SERVICES GRID */}
      <div className="services-container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
          </div>
        ))}
      </div>

    </section>
  );
};

export default Services;